import { get } from "lodash";
import getAppConfig from "../global/utils/getAppConfig"
import fetchService from "../services/FetchService";

const apiUrl = getAppConfig();

// Generic Api Calls

export const fetchCountries = async (language = 'en') => {
  const requestData = {
    url: `${apiUrl.FETCH_COUNTRIES_API}?lang=${language}`,
    method: 'Get',
  };
  return await fetchService(requestData).then(res => {
    if (get(res, 'data', '')) {
      return res.data.countries.map(o => ({ fields: { displayText: { value: o.value }, key: { value: o.value }, id: o.key } }));
    }
    return []
  });
}
